import React, { useState } from 'react';

import { Avatar, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import MenuButton from '../../../../components/MenuButton/MenuButton';
import ConfirmationModal from '../../../../components/Modals/ConfirmationModal/ConfirmationModal';
import { useAppSelector, useTimeAgoHook } from '../../../../shared/hooks';
import { IChannelPostDetails } from '../../../../types/communityTypes';
import { ROUTES } from '../../../../types/routes';
import CreatorTag from '../../components/CreatorTag';
import CommunityChannelTitle from './CommunityChannelTitle';
import CommunityPostMenuModel from './CommunityPostMenuModel';

type Props = {
  communityPostDetails: IChannelPostDetails;
  isRepost: boolean;
  isPDP?: boolean;
};

const CommunityPostHeader: React.FC<Props> = ({
  communityPostDetails,
  isRepost,
  isPDP,
}) => {
  // const { hostMetadata } = useAppSelector((state) => state?.app);
  const navigate = useNavigate();
  const { hostMetadata } = useAppSelector((state) => state?.app);
  const { post } = communityPostDetails;
  const [showRemovePostWarning, setShowRemovePostWarning] = useState(false);
  const [showMenuModel, setShowMenuModel] = useState(false);
  return (
    <div className="community-post_container">
      <Avatar
        src={post?.postedBy?.profilePicUrl}
        size={45}
        onClick={() => {
          navigate(ROUTES.USER_PROFILE.replace(':userId', post?.postedBy?._id));
        }}
        style={{ cursor: 'pointer' }}
      />

      <div className="community-post_container_wrapper">
        <div style={{ display: 'flex' }}>
          <Typography.Text
            ellipsis={true}
            className="community-post_container_wrapper_user-title"
            style={{ fontSize: 16, fontWeight: 600, cursor: 'pointer' }}
            onClick={() => {
              navigate(
                ROUTES.USER_PROFILE.replace(':userId', post?.postedBy?._id),
              );
            }}>
            {/* {postStatus === 'denied'
            ? UNKNOWN_USER
            : (isMyPost ? userDetails.name : post.creatorName || '') ||
              DELETED_USER} */}
            {post?.postedBy?.name}
          </Typography.Text>
          {communityPostDetails?.postedBy === hostMetadata?.creator?._id ? (
            <CreatorTag />
          ) : null}
        </div>

        <div className="community-post_container_wrapper_channels">
          <CommunityChannelTitle channels={post?.channels || []}>
            {useTimeAgoHook(
              post.updatedAt || post.scheduleAt || post.createdAt,
            )}
            &nbsp;•&nbsp;
          </CommunityChannelTitle>
        </div>
      </div>
      {isRepost || isPDP ? null : (
        <MenuButton onClick={() => setShowMenuModel(true)} />
      )}

      <CommunityPostMenuModel
        showMenu={showMenuModel}
        closeModel={() => setShowMenuModel(false)}
        communityPostDetails={communityPostDetails}
        onTogglePinPost={() => {}}
      />
      <ConfirmationModal
        title="Remove"
        open={showRemovePostWarning}
        handleOk={() => {}}
        handleCancel={() => {
          setShowRemovePostWarning(false);
        }}
        message="Do you really want to delete the post?"
        okayButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </div>
  );
};

export default CommunityPostHeader;
